import DateObject from "react-date-object";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

export const toJalaliDate = (isoString, format = "YYYY/MM/DD") => {
  if (!isoString) return "";
  try {
    const gregorianDate = new DateObject({
      date: isoString,
      calendar: gregorian,
      locale: gregorian_en,
    });
    return gregorianDate.convert(persian, persian_fa).format(format);
  } catch {
    return "";
  }
};

export const toJalaliDateTime = (isoString) => toJalaliDate(isoString, "YYYY/MM/DD HH:mm");